module.exports = __webpack_public_path__ + "static/media/informalgray.71af8ade.svg";